import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import { getUser, getIdToken, getClient } from "../../../../utils/storage";

import InnerLoader from "../../../InnerLoader";
import { fetchMMCampaign } from "../../../../services/dashboard-api";

const RequestsSummary = (props) => {
  const [numberOfRequests, setNumberOfRequests] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { ref } = useParams();
  const [toast, setToast] = useState({
    show: false,
    type: "",
    message: "",
  });
  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_total_requests`,
  //       {
  //         uid: getUser().uid,
  //         idToken: getIdToken(),
  //         clientRef: getClient().clientRef,
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then(({ data }) => {
  //       setIsLoading(false);
  //       setNumberOfRequests(data.totalNumberOfRequests);
  //     })
  //     .catch((error) => {
  //       console.log("Error getting total requests", error);
  //     });
  // }, []);

  useEffect(() => {
    console.log("ref");
    const getRequest = async () => {
      try {
        setIsLoading(true);

        const { data } = await fetchMMCampaign(ref);

        console.log("Campaign response:", data);

        setNumberOfRequests(data?.totalCampaigns ?? 0);
      } catch (error) {
        console.log("Error getting request data", error);

        setToast({
          show: true,
          type: "warning",
          message:
            error.response?.data?.message ||
            "We had problems retrieving request data",
        });
      } finally {
        setIsLoading(false);
      }
    };

    getRequest();
  }, [ref, setToast]);

  console.log("numberOfRequests", numberOfRequests);

  return (
    <div className="card-section horizontal padded expand">
      {isLoading ? (
        <InnerLoader />
      ) : (
        <>
          <div className="data huge">{numberOfRequests}</div>
          <h3 className="move-down">Requests</h3>
        </>
      )}
    </div>
  );
};

export default RequestsSummary;
